import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { Counter } from '@factorialco/f0-react/dist/experimental'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import CommentCard from 'modules/project_management/components/myProjects/CommentCard'
import { CustomGlobalTimeRecord } from 'modules/project_management/lib/getCustomGlobalTimeRecordsForMyProjectsTable'
import { getCustomRecordsCommentsByDate } from 'modules/project_management/lib/getCustomRecordsCommentsByDate'
import type ProjectsStore from 'modules/project_management/store/models/Projects'

export interface MyProjectsCommentsSidepanelProps {
  onClose: () => void
  open: boolean
  sortedRecords: CustomGlobalTimeRecord[]
  projectsStore: ProjectsStore
  weekStart: string
  weekEnd: string
}

export const MyProjectsCommentsSidepanel = ({
  onClose,
  open,
  sortedRecords,
  projectsStore,
  weekStart,
  weekEnd,
}: MyProjectsCommentsSidepanelProps) => {
  const commentsPresent = sortedRecords.length > 0

  const widgetComments = getCustomRecordsCommentsByDate(sortedRecords)

  useEffect(() => {
    track(trackingEvents.projectManagement.myProjects.commentsSidepanel.open)
  }, [])

  return (
    <Sidepanel
      width="narrow"
      title={i18n.t('project_management.comments_my_projects.sidepanel.title')}
      open={open}
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
      boxPadding={false}
    >
      {commentsPresent && (
        <>
          {widgetComments.map((widgets) => (
            <Box key={widgets.date}>
              <Divider />
              <Box paddingX="s12">
                <Box gap="s8" paddingY="s16" paddingX="s16" flexDirection="row" alignItems="center">
                  <Text.Normal size="200" weight="normal" color="grey1000">
                    {widgets.date}
                  </Text.Normal>
                  <Counter value={widgets.count} />
                </Box>
                <Box gap="s6" paddingBottom="s24">
                  {widgets.comments.map((comment) => (
                    <CommentCard
                      key={comment.id}
                      comment={comment}
                      projectsStore={projectsStore}
                      weekStart={weekStart}
                      weekEnd={weekEnd}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
          ))}
        </>
      )}
    </Sidepanel>
  )
}
